import * as __au2ViewDef from './general-tab-attribute.html';
import {customElement, inject} from "aurelia";
import {SelectedObjectService} from "../../../../resources/services/selected-object";
import {Attribute} from "../../../../../../mmar-global-data-structure/models/meta/Metamodel_attributes.structure";
import {Validation} from "../../../../resources/services/validation";

@customElement({ ...__au2ViewDef, name: "general-tab-attribute" })
@inject(SelectedObjectService)
@inject(Validation)
export class GeneralTabAttribute {
    private facetsList: string[] = [];

    constructor(
        private selectedObjectService: SelectedObjectService,
    ) {
    }

    handleItemsSelected(event) {
        (this.selectedObjectService.selectedObject as Attribute).attribute_type =
            event.detail[0];
    }

    attached() {
        this.populateFacetList();
    }

    getImage() {
        const geometry = (this.selectedObjectService.selectedObject as Attribute)
            .attribute_type.geometry;
        return this.selectedObjectService.getIcon(geometry?.toString());

    }

    isValid(value: string, regex: string | RegExp) {
        if (typeof regex === "string") regex = new RegExp(regex);
        if (regex) return regex.test(value);
    }

    populateFacetList() {
        const input = document.getElementById('facetInput') as HTMLInputElement;
        const regex = new RegExp('[^|]+');
        if (input.value === '') {
            this.facetsList = [];
            return;
        }

        if (this.isValid(input.value, regex)) {
            input.classList.remove('is-invalid');
            this.facetsList = input.value.split('|');
        } else {
            //should never happen
            input.classList.add('is-invalid');
        }


    }

    validateDefaultValue(event) {
        const regex = (this.selectedObjectService.selectedObject as Attribute).attribute_type.regex_value;
        const defaultValue = (this.selectedObjectService.selectedObject as Attribute).default_value;
        if (this.isValid(defaultValue, regex)) {
            event.target.classList.remove('is-invalid');
        } else {
            event.target.classList.add('is-invalid');
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = GeneralTabAttribute;

    // @ts-ignore
    const proto = GeneralTabAttribute.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }